'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductImageCarousel = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

require('slick-carousel');

var _CarouselSection2 = require('../carousel/CarouselSection');

var _ShopifySection = require('../ShopifySection');

var _Responsive = require('../../settings/Responsive');

var ResponsiveSizes = _interopRequireWildcard(_Responsive);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *  Product Page Image Carousel
 *    Scripts for the product carousel utilising Slick.
 *
 *
 *  Version:
 *    1.0.0 - 2020/03/12
 */

var CONTAINER_SELECTOR = '[data-product-image-carousel-container]';
var CAROUSEL_SELECTOR = '[data-product-image-carousel]';
var THUMBNAIL_CONTAINER_SELECTOR = '[data-product-image-carousel-thumnails]';
var THUMBNAIL_SELECTOR = '[data-product-image-carousel-image]';
var SELECTOR_PROGRESS = '[data-product-image-carousel-progress]';

var ProductImageCarousel = exports.ProductImageCarousel = function (_CarouselSection) {
  (0, _inherits3.default)(ProductImageCarousel, _CarouselSection);

  function ProductImageCarousel(container) {
    (0, _classCallCheck3.default)(this, ProductImageCarousel);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ProductImageCarousel.__proto__ || Object.getPrototypeOf(ProductImageCarousel)).call(this, container));

    _this.carouselContainer = container.find(CAROUSEL_SELECTOR);
    _this.thumbnailContainer = container.find(THUMBNAIL_CONTAINER_SELECTOR);

    _this.init();

    _this.container.on('click touchend', THUMBNAIL_SELECTOR, function (e) {
      return _this.onThumbnailClick(e);
    });
    _this.container.on('beforeChange', function (e, slick, currentSlide, nextSlide) {
      return _this.onSlideChange(slick, nextSlide);
    });
    return _this;
  }

  (0, _createClass3.default)(ProductImageCarousel, [{
    key: 'init',
    value: function init() {
      var _this2 = this;

      this.imageSlick = this.initCarousel(this.carouselContainer, {
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        fade: false,
        cssEase: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
        adaptiveHeight: true,
        responsive: [{
          breakpoint: ResponsiveSizes.medium - 1,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            fade: true
          }
        }]
      });

      this.thumbnailSlick = this.initCarousel(this.thumbnailContainer, {
        infinite: true,
        dots: false,
        arrows: false,
        focusOnSelect: true,
        centerMode: false,
        draggable: true,
        adaptiveHeight: true,
        swipeToSlide: true,
        cssEase: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
        responsive: [{
          breakpoint: ResponsiveSizes.medium - 1,
          settings: { slidesToShow: 4 }
        }]
      });

      //Lazy load fix
      this.container.find('img').on('load', function (e) {
        if (_this2.timeout) clearTimeout(_this2.timeout);
        _this2.timeout = setTimeout(function () {
          [_this2.thumbnailContainer, _this2.carouselContainer].forEach(function (e) {
            return e.slick('refresh');
          });
          _this2.goToSlide(0);
        }, 300);
      });
    }

    //Thumbnail Navigation

  }, {
    key: 'onThumbnailClick',
    value: function onThumbnailClick(e) {
      var self = $(e.currentTarget);
      var index = self.attr('data-index');
      this.goToSlide(index);
    }
  }, {
    key: 'goToSlide',
    value: function goToSlide(index) {
      if (!index) return;
      this.carouselContainer.slick('slickGoTo', index);
      this.thumbnailSlick.slick('slickGoTo', index);
      this.setActiveImage(index);
    }
  }, {
    key: 'setActiveImage',
    value: function setActiveImage(index) {
      $(THUMBNAIL_SELECTOR).removeClass('is-active');
      $(THUMBNAIL_SELECTOR + '[data-index="' + index + '"]').addClass('is-active');
    }
  }, {
    key: 'onSlideChange',
    value: function onSlideChange(slick, nextSlide) {
      var progress = (parseInt(nextSlide) + 1) / slick.slideCount * 100;
      $(SELECTOR_PROGRESS).css({ 'width': progress + '%' });
    }
  }]);
  return ProductImageCarousel;
}(_CarouselSection2.CarouselSection);

(0, _ShopifySection.register)(CONTAINER_SELECTOR, ProductImageCarousel);